import Stack from '@mui/material/Stack';
import React from 'react';

import {GndiSaoPauloLogo} from '../../GndiSaoPaulo';
import {HapvidaLogo} from '../../Hapvida';
import {HapNdiLogoProps} from './types';

export function HapNdiLogo({isMobile}: HapNdiLogoProps) {
	return (
		<Stack
			direction="row"
			justifyContent="center"
			alignItems={isMobile ? 'start' : 'center'}
			gap={2}
			maxWidth={215}>
			<HapvidaLogo height={40} />
			<GndiSaoPauloLogo height={isMobile ? 37 : 50} isMobile={isMobile} />
		</Stack>
	);
}
